import React from "react";
import Line from "../../../../../Assets/Images/SmallHrLine.svg";
import "../../../../../Assets/Styles/MenuItemIcon.scss";

const MenuItemIcon = (props) => {
  return (
    <React.Fragment>
      {props.IsMobile ? (
        <span className="menu-item-icon-holder is-mobile mobile-nav-icon-holder">
          <img id={props.Id + "-hr"} src={Line} alt="-" className="hr" />
          <img id={props.Id + "-vr"} src={Line} alt="+" className="vr" />
        </span>
      ) : (
        <span className="menu-item-icon-holder is-desktop">
          <img id={props.Id + "-hr"} src={Line} alt="-" className="hr" />
          <img id={props.Id + "-vr"} src={Line} alt="+" className="vr" />
        </span>
      )}
    </React.Fragment>
  );
};
export default MenuItemIcon;
